import { createSlice } from "@reduxjs/toolkit";
import { AppThunk, RootState } from ".";
import { PaymentService } from "../services/PaymentService";
import { withdrawalReceipt } from "../types/transactions";

export enum ReceiptCategory {
    withdrawal = 'withdrawal',
    charge = 'charge',
    none = 'none'
}

type ReceiptSliceType = {
    receiptStatus: ReceiptCategory,
    receiptData: Object
}

enum ReceiptStatus {
    processing = "processing",
    done = "done",
    success = "success",
    empty = "empty",
    error = "error",
    noData = "noData"
}

const initialState: ReceiptSliceType = {
    receiptStatus: ReceiptCategory.none,
    receiptData: {}
}

const receiptSlice = createSlice({
    name: 'receipt',
    initialState,
    reducers: {
        setReceiptStatus : (state, action) => {
            state.receiptStatus = action.payload;
        },
        setReceiptData: (state, action)=> {
            state.receiptData = action.payload;
        }
    }
});

// EXPORT DEFAULT
export const {
    setReceiptStatus,
    setReceiptData,
} = receiptSlice.actions

export default receiptSlice.reducer;

export const getReceiptStatus = (state: RootState) => state.receipt.receiptStatus;
export const getReceiptData = (state: RootState) => state.receipt.receiptData;

export const getReceiptRequest = (txId: string): AppThunk<Promise<void>> => async (dispatch, getState) => {
    
    let receipt = await PaymentService.getReceipt(txId);
    let status;
    
    if (receipt) {
        status = ReceiptStatus.empty;
        if (receipt.code === 200) status = ReceiptStatus.success
        if (receipt.code !== 200) status = ReceiptStatus.noData
    } else {
        status = ReceiptStatus.error;
    }
    receipt = {status, ...receipt}
    
    dispatch(setReceiptData(receipt))
    dispatch(setReceiptStatus(ReceiptCategory.charge))
    
}

export const getWithdrawalReceipt = (txId: string): AppThunk<Promise<void>> => async (dispatch, getState) => {
    
    let receipt : withdrawalReceipt = await PaymentService.getWIthdrawalReceipt(txId);
    
    dispatch(setReceiptData(receipt))
    dispatch(setReceiptStatus(ReceiptCategory.withdrawal))
    
}